<template>
  <div :class="'add_navbg add_navbg_' + fairDetail.multi_color_selection" height="100%">
    <div v-if="template === '2'">
      <yd-accordion>
        <yd-accordion-item>
          <div class="nav_box" style="padding: .24rem;">
            <div v-for="term of termList" :key="term.id">
              <a :href="term.url" class="nav">{{term.name}}</a>
            </div>
          </div>
        </yd-accordion-item>
      </yd-accordion>
      <!-- 图片区域 -->
      <div class="warp">
        <img :src="fairDetail.mimg">
      </div>
      <!-- 图片区域结束 -->
    </div>
    <div v-if="template === '1'">
      <yd-flexbox>
        <yd-flexbox-item v-if="0" class="fariinfo">
          <h3>{{fairDetail.fair_name}}</h3>
          <p>{{fairDetail.reserve_time}}至{{fairDetail.end_reserve_time}}</p>
        </yd-flexbox-item>
      </yd-flexbox>
      <yd-flexbox>
        <yd-flexbox-item class="bottom l-flexbox-item">
          <yd-grids-group :rows="3" class="l-grids-group">
            <yd-grids-item
              v-for="term of termList"
              :key="term.id"
              class="l-grids-item"
              @click.native="activeCheck(term.url)"
            >
              <img
                slot="icon"
                :onerror="termDefaultImg(term)"
                :src="term.img"
                alt=""
              >
              <span slot="text">{{ term.name }}</span>
            </yd-grids-item>
          </yd-grids-group>
        </yd-flexbox-item>
      </yd-flexbox>
    </div>

  </div>
</template>

<script type="text/babel">
import axios from 'axios'

export default {
  data () {
    return {
      termList: [],
      fairDetail: [],
      template: '',
      backgroupData: [],
      defaultImg: 'this.src="' + require('../../assets/image/term-default/online.png') + '"',
      defaultImgData: {
        'online': 'this.src="' + require('../../assets/image/term-default/online.png') + '"',
        'hotel': 'this.src="' + require('../../assets/image/term-default/hotel.png') + '"',
        'order': 'this.src="' + require('../../assets/image/term-default/order.png') + '"',
        'voucher': 'this.src="' + require('../../assets/image/term-default/voucher.png') + '"',
        'content': 'this.src="' + require('../../assets/image/term-default/list.png') + '"',
        'lianxi': 'this.src="' + require('../../assets/image/term-default/lianxi.png') + '"',
        'jieji': 'this.src="' + require('../../assets/image/term-default/jieji.png') + '"',
        'zhinan': 'this.src="' + require('../../assets/image/term-default/jieshao.png') + '"',
        'jieshao': 'this.src="' + require('../../assets/image/term-default/jieshao.png') + '"',
        'jiabin': 'this.src="' + require('../../assets/image/term-default/jiabin.png') + '"',
        'list': 'this.src="' + require('../../assets/image/term-default/list.png') + '"',
        'piclist': 'this.src="' + require('../../assets/image/term-default/list.png') + '"'
      },
      params: this.$route.params
    }
  },
  methods: {
    getFairDetail () {
      let data = {id: this.params.id, limit: 20}
      axios
        .post('/fair/fair-detail', data)
        .then(this.getFairDetailSucc)
    },
    getFairDetailSucc (res) {
      res = res.data
      if (res.status && res.data) {
        this.termList = res.data.termList
        this.fairDetail = res.data.fair
        if (this.fairDetail.mimg === '') {
          this.fairDetail.mimg = require('../../assets/image/long_figure.jpg')
        }
        this.template = res.data.fair.template
      } else {
        // this.$dialog.alert({mes: '会议不存在'})
      }
    },
    termDefaultImg (term) {
      let img = this.defaultImg
      if (this.defaultImgData[term.ident_m]) {
        img = this.defaultImgData[term.ident_m]
      }
      return img
    },
    activeCheck (url) {
      window.location.href = url
    }
  },
  mounted () {
    this.getFairDetail()
  }
}
</script>

<style lang="stylus" scoped>
.bottom
  position absolute
  bottom 30px
  width 100%

>>> .yd-grids-3:before
  height 0

>>> .l-flexbox-item .l-grids-group .yd-grids-3
  padding 0 .15rem
  background none

>>> .l-flexbox-item .l-grids-group .yd-grids-txt
  color #ffffff

.l-flexbox-item .l-grids-item
  width 32%
  margin-bottom .15rem
  margin-right 1.995%
  background-color rgba(15, 15, 135, 0.4)

.l-flexbox-item .l-grids-item:nth-child(3n)
  margin-right 0

>>> .l-flexbox-item .l-grids-group .yd-grids-3 .yd-grids-item:not(:nth-child(3n)):before
  width 0

>>> .l-flexbox-item .l-grids-group .yd-grids-item:after
  height 0

  .fariinfo {
    margin: .3rem;
  }

  .fariinfo h3 {
    line-height: 1.5;
    font-size: .45rem;
  }

  .fariinfo p {
    line-height: 2;
    font-size: .3rem;
  }

  .yd-flexview
    max-width: 1920px !important

  .yd-grids-item::after
    display: none

  .yd-grids-item::before
    display: none

  .warp
    width: 100%
    overflow: hidden

  .warp img
    max-width: 100%
    width: 100%

  .yd-accordion
    position: fixed
    background: none
    right: 0
    top: .6rem

  .nav_box
    padding: .2rem .4rem !important
    margin-right: .4rem
    background-color: rgba(255, 255, 255, 0.9)
    border-radius: .1rem
    position relative

  .nav
    position: relative
    color: #333
    font-size .4rem
    line-height: .9rem

  .nav::after
    content: ""
    width: calc(100% + .4rem)
    height: 1px
    background-color: #f2f2f2
    position: absolute
    bottom: -.1rem
    left: -.2rem

  .nav_box > :last-child a::after
    display: none
</style>



// WEBPACK FOOTER //
// src/views/template1/FairDetail.vue